import INFTCategory from '../models/INFTCategory'

const CategoryList: INFTCategory[] = [
  { id: null, name: 'All' },
  { id: 1, name: 'Art' },
  { id: 2, name: 'Games' },
  { id: 3, name: 'Photography' },
  { id: 4, name: 'Memes' },
  { id: 5, name: 'NSFW' }
]

export default CategoryList
